import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import AnimateHeight from "react-animate-height";
import styles from "./Tile.module.scss";
import cn from "classnames";
import { useWindowSize } from "../../hooks/use-window-size";
import classNames from "classnames";
import useDeviceDetect from "../../hooks/use-is-device-detect";
import { scrollView } from "../../libs/scrollView";
import { fireGA, fireSupGA } from "../../hooks/tagging";

const Tile: FunctionComponent<{
    copy: any; index: number; isSelected: boolean; handleClick: any; userStylesApplied: boolean; tileHeightOpen: any; setTileHeightOpen: any; tileHeightClosed: number; setTileHeightClosed: any; tileRef: any; contentRef: any; focus: string, titleHeight: number
}> = ({
    copy, index, isSelected, handleClick, userStylesApplied,
    tileHeightOpen,
    setTileHeightOpen,
    tileHeightClosed,
    setTileHeightClosed,
    tileRef,
    contentRef,
    titleHeight,
    focus
}) => {

        const deviceDetect = useDeviceDetect();
        const windowSize = useWindowSize();
        const isMobile = windowSize.width < 1080 && deviceDetect.isMobile;
        const [selected, setSelected] = useState(isSelected);
        const arrowAlt = isMobile ? selected ? "Up Arrow" : "Down Arrow" : "";
        const isDefaultOpen = 0 == index;
        const [selectedDesktop, setSelectedDesktop] = useState(isDefaultOpen);

        const thisRef = useRef<HTMLParagraphElement>(null);

        const initialized = useRef(false);

        const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';

        const titleTopPosition = tileHeightClosed - titleHeight;

        useEffect(() => {
            if (!initialized.current) {

                if (thisRef.current) {
                    initialized.current = true;
                    const sups = thisRef.current.querySelectorAll('A')
                    sups.forEach((sup: any) => {
                        const keyUpHandler = (event: any) => {
                            if (event.which === 13) {
                                event.preventDefault();
                                event.stopPropagation();
                                fireSupGA({ clickText: sup.innerText });

                                const target = document.getElementById(`fn-${sup.innerText}`)

                                scrollView(target, { behavior: "smooth", block: "center" }, () => setTimeout(() => {
                                    target!.focus()
                                }, 500));
                            }
                        }
                        sup.addEventListener('keydown', (e: any) => keyUpHandler(e));

                        const clickHandler = (event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            fireSupGA({ clickText: sup.innerText });

                            const target = document.getElementById(`fn-${sup.innerText}`)

                            scrollView(target, { behavior: "smooth", block: "center" }, () => setTimeout(() => {
                                target!.focus()
                            }, 500));

                        }
                        sup.addEventListener('click', (e: any) => clickHandler(e));

                        return () => {
                            document.removeEventListener('keydown', keyUpHandler);
                            document.removeEventListener('click', clickHandler);
                        };
                    })
                }

            }
        })

        useEffect(() => { // Fix when the user the bookmark favlet 
            const targetElement = tileRef.current.querySelector('h2');

            // Store the initial letter spacing value
            const initialSpacing = window.getComputedStyle(targetElement).getPropertyValue('letter-spacing');

            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    // Check if the mutation was an attribute change
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        // Use getComputedStyle to get the actual, computed value
                        const newSpacing = window.getComputedStyle(targetElement).getPropertyValue('letter-spacing');

                        // Compare against the old value to ensure a meaningful change occurred
                        const oldValue = mutation.oldValue ? (newSpacing === mutation.oldValue ? "initial value" : mutation.oldValue) : "N/A";
                        if (newSpacing !== oldValue) {
                            setTileHeightClosed(window.innerWidth < 1400 ? 600 : 500);
                            setTileHeightOpen(window.innerWidth < 1400 ? 960 : 700);

                        }
                    }
                });
            });

            // Start observing the target element for attribute changes
            observer.observe(targetElement, {
                attributes: true,                 // Watch for attribute changes
                attributeFilter: ['style'],       // Only watch the 'style' attribute
                attributeOldValue: true           // Provide the old attribute value in the mutation record
            });
        }, []);

        useEffect(() => { // Setting the height of the content's top position
        if (contentRef.current) {
          const parentDiv = contentRef.current.parentNode;
          parentDiv.style.top = titleTopPosition + 'px';
        }
        }, [titleHeight]); // Run anytime titleHeight prop changes



        const isActiveClass = () =>
            isMobile
                ? isSelected
                : selectedDesktop

        const buttonID = `tab-${index}`
        const panelID = `panel-${index}`
        const headerID = `tile-${index}`


        const clickHandler = (e: any) => {

            if (e.target.tagName === "A" || e.target.tagName === "SUP") return;

            if (isMobile) {
                handleClick();
                setSelected(!isSelected)
            }
            else {
                setSelectedDesktop(!selectedDesktop)
            }

            fireGA("C5", {//good
                innerText: `${isActiveClass() ? 'collapse' : 'expand'} - ${e.currentTarget.getElementsByTagName('h2')[0].innerText.toLowerCase()}`,
                userActionTaken: `${isActiveClass() ? 'collapse' : 'expand'}`//good
            })


        }
        console.log(tileHeightClosed, titleHeight)
        console.log(tileHeightOpen)
        return (<div
            className={cn([styles.tile, `${isActiveClass() ? 'active' : ''}`, styles[copy.class], 'no-parallax'])}
            tabIndex={-1}
            data-lang={dataLang}
            aria-label={copy.alt}
            onClick={(e) => {
                clickHandler(e)
            }}
            onKeyDown={(e) => {
                if (e.which === 13) clickHandler(e);
                if (e.which === 32) {
                    e.preventDefault();
                    clickHandler(e)
                }
            }}
            ref={tileRef}
        >
            <AnimateHeight
                className={classNames([styles.panel, isActiveClass() && styles.active, userStylesApplied && 'user-styles'])}
                duration={500} height={isActiveClass() ? tileHeightOpen : tileHeightClosed} 
            >
                <div className={styles.content} ref={contentRef}>

                    <div className={styles.left}>
                        <span className={classNames([isActiveClass() && styles.selectedArrow])} aria-label={arrowAlt} />
                    </div>

                    <div className={styles.right}>
                        <div /*TAB*/
                            className={classNames([styles.title, , `${isActiveClass() && copy.class === "bg3" ? styles.gradient : ''}`])}
                            id={buttonID}
                        >
                            {/*TILE*/}
                            <h2
                                tabIndex={0}
                                aria-controls={panelID}
                                aria-expanded={isActiveClass()}
                                className={classNames([isActiveClass() && styles.active])}
                                // role="presentation"
                                role="button"
                                id={headerID}

                            >{copy.heading}</h2>

                        </div>


                        <div
                            /*PANEL*/
                            id={panelID}
                            role="region"
                            // aria-labelledby={buttonID}
                            aria-labelledby={headerID}
                            aria-hidden={!isActiveClass()}
                            className={classNames([styles.body, isActiveClass() && styles.active, 'no-parallax'])}
                        >
                            <p className={classNames(['no-parallax'])} ref={thisRef} dangerouslySetInnerHTML={{ __html: copy.body[focus] }} />
                        </div>
                    </div>


                </div>
            </AnimateHeight>
        </div>);
    };

export default Tile;

